import { APP_LINKS, NAVBAR_LINKS } from '@utils/variables';

/**
 * Extract the page id from the pathname
 * @param pathname the pathname to extract the page id from
 * @returns {string} the page id or an empty string
 */
function extractPageIdFromPathname(pathname: string): string {
	try {
		if (pathname === '/') {
			return APP_LINKS.home.id;
		}

		const result = NAVBAR_LINKS.find(({ href }): boolean => {
			if (pathname === href) {
				return true;
			}

			if (href !== '/' && pathname.includes(href)) {
				return true;
			}

			return false;
		});

		return result?.id || '';
	} catch {
		return '';
	}
}

export { extractPageIdFromPathname };
